import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getDistributors(axios: AxiosInstance, page?: number, itemsPerPage?: number): Promise<any> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/distributor`, {
    params: {
      page,
      itemsPerPage,
    },
  });
  return data;
}

export default function useDistributorsQuery(page?: number, itemsPerPage?: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(page, itemsPerPage),
    queryFn: () => getDistributors(axios, page, itemsPerPage),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(page?: number, itemsPerPage?: number) {
  return ['Distributors', page, itemsPerPage] as const satisfies QueryKey;
}

useDistributorsQuery.getKey = getKey;
